import ResultColumn from "./ResultColumn";
import SolutionColumn from "./SulotionColumn";
import { submissionsApi } from "../../../../../../../utils"
import { SwitchToggleFourOptionEnum } from "../../../../../../../models/SwitchToggleFourOptionEnum";
import classes from "./Row.module.css"

const SubmmisionRow = ({ currentAssessment, submission, index, submissions, setSubmissionScore, assessments }) => {

    const updateSubmissionsScore = (newSubmision, index, success, score) => {
        if (newSubmision[index].submittedByUser.isGroup) {
            // find all submission with submitted user the same group;
            newSubmision.forEach((s, i) => {
                if (s.submittedByUser?.id === newSubmision[index].submittedByUser.id) {
                    newSubmision[i] = { ...newSubmision[i], success, score }
                }
            })
        }
        else {
            newSubmision[index] = { ...newSubmision[index], success, score }
        }
    }

    const handleCheckStatus = (value) => {
        let scoreInput = null
        let successInput = null
        if (value == SwitchToggleFourOptionEnum.Correct) {
            scoreInput = submission.assessmentMaxScore ? submission.assessmentMaxScore : 100
            successInput = true
        }
        else if (value == SwitchToggleFourOptionEnum.InCorrect) {
            scoreInput = 0
            successInput = false
        }
        const submissionFeedbackInput = {
            id: submission.id,
            score: scoreInput,
            success: successInput
        }
        submissionsApi.submissionsScorePost({ submissionFeedbackInput }, (error, resdata, response) => {
            if (error)
                console.log(error);
            else {
                let flagnewScore = false
                let numAnsweredStudents = submissions.filter(s => s.success != null).length
                if (submissions[index].success == null) {
                    numAnsweredStudents = numAnsweredStudents + 1
                    flagnewScore = true
                }
                let newSubmision = [...submissions];
                let currentAssessmentIndex = assessments.findIndex(a => a.id == currentAssessment.id)
                let newAssessments
                if (value == SwitchToggleFourOptionEnum.Correct) {
                    updateSubmissionsScore(newSubmision, index, true, 1);
                    newAssessments = [...assessments]
                    if (flagnewScore) {
                        newAssessments[currentAssessmentIndex] = {
                            ...newAssessments[currentAssessmentIndex],
                            scoreAverage: (newAssessments[currentAssessmentIndex].scoreAverage + 1) / numAnsweredStudents
                        }
                    }
                    else {
                        newAssessments[currentAssessmentIndex] = {
                            ...newAssessments[currentAssessmentIndex],
                            scoreAverage: newAssessments[currentAssessmentIndex].scoreAverage + (1 / numAnsweredStudents)
                        }
                    }

                }
                else {
                    updateSubmissionsScore(newSubmision, index, false, 0);
                    newAssessments = [...assessments]
                    if (flagnewScore) {
                        newAssessments[currentAssessmentIndex] = {
                            ...newAssessments[currentAssessmentIndex],
                            scoreAverage: (newAssessments[currentAssessmentIndex].scoreAverage - 1) / numAnsweredStudents
                        }
                    }
                    else {
                        newAssessments[currentAssessmentIndex] = {
                            ...newAssessments[currentAssessmentIndex],
                            scoreAverage: newAssessments[currentAssessmentIndex].scoreAverage - (1 / numAnsweredStudents)
                        }
                    }
                }
                setSubmissionScore(newSubmision, newAssessments)
            }
        })
    }


    return (
        <div className={classes.Row}>
            <ResultColumn autoScore={currentAssessment?.autoScore} success={submission.success} currentAssessment={currentAssessment} handleCheckStatus={handleCheckStatus} submissions={submissions}></ResultColumn>
            <div className={classes.Name}>{submission.submittedByFirstName} {submission.submittedByLastName}</div>
            <SolutionColumn currentAssessment={currentAssessment} submission={submission}></SolutionColumn>
            <div className={classes.Score}>{submission.assessmentMaxScore && submission.score !== null ? `${Math.round((submission.assessmentMaxScore - submission.assessmentMinScore) * submission.score * 100) / 100}/${submission.assessmentMaxScore}` : '-'}</div>
        </div>
    )
}
export default SubmmisionRow